/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.18",
    versionName: "0.2.0-nightly.2025.7.18",
    versionChannel: "nightly",
    buildDate: "2025-07-18T00:07:55.078Z",
    commitHash: "3be1aaaa6c1f07ad9a9cf9a6523f3e0e2d5554b2",
};
